import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { notifications as notifApi } from '../utils/api';
import toast from 'react-hot-toast';

const typeIcon = {
  NEW_APPLICATION: '📝', JOB_ASSIGNED: '🎉', JOB_COMPLETED: '✅',
  TOKEN_APPROVED: '🪙', TOKEN_REJECTED: '❌', MOD_APPROVED: '🛡️',
  MOD_REJECTED: '❌', HIRE_REQUEST: '🤝', CONTACT_VIEWED: '👀',
  SEEK_AD_STATUS: '📢', DEFAULT: '🔔',
};

export default function Notifications() {
  const { t, user, fetchUnread } = useApp();
  const navigate = useNavigate();
  const [items,   setItems]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { navigate('/login'); return; }
    notifApi.list()
      .then(r => setItems(r.notifications ?? []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [user, navigate]);

  const markRead = async id => {
    await notifApi.markRead(id).catch(() => {});
    setItems(ns => ns.map(n => n.id === id ? { ...n, is_read: 1 } : n));
    fetchUnread();
  };

  const markAll = async () => {
    await notifApi.markAllRead().catch(() => {});
    setItems(ns => ns.map(n => ({ ...n, is_read: 1 })));
    fetchUnread();
    toast.success(t('mark_all_read'));
  };

  const unread = items.filter(n => !n.is_read).length;

  if (loading) return <div className="page-loader"><div className="spinner" /></div>;

  return (
    <div className="container-sm" style={{ paddingTop: '36px', paddingBottom: '60px' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'24px' }}>
        <div>
          <h1 style={{ fontSize:'24px', fontWeight:700 }}>{t('notifications')}</h1>
          {unread > 0 && <p style={{ fontSize:'13px', color:'var(--text3)', marginTop:'4px' }}>{unread} unread</p>}
        </div>
        {unread > 0 && (
          <button className="btn btn-outline btn-sm" onClick={markAll}>{t('mark_all_read')}</button>
        )}
      </div>

      {items.length === 0 ? (
        <div className="empty-state">
          <div style={{ fontSize:'48px', marginBottom:'12px' }}>🔔</div>
          <p>{t('no_notifications')}</p>
        </div>
      ) : (
        <div className="stagger">
          {items.map(n => (
            <div key={n.id}
              className="card"
              style={{
                marginBottom: '8px',
                display: 'flex',
                gap: '14px',
                alignItems: 'flex-start',
                opacity: n.is_read ? 0.65 : 1,
                background: n.is_read ? 'var(--surface)' : 'var(--surface)',
                borderLeft: n.is_read ? '1px solid var(--border)' : '3px solid var(--brand)',
                cursor: n.is_read ? 'default' : 'pointer',
                transition: 'opacity var(--transition)',
              }}
              onClick={() => !n.is_read && markRead(n.id)}
            >
              <div style={{ fontSize:'22px', flexShrink:0, marginTop:'2px' }}>
                {typeIcon[n.type] ?? typeIcon.DEFAULT}
              </div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontWeight: n.is_read ? 400 : 600, fontSize:'14px', color:'var(--text)', marginBottom:'3px' }}>
                  {n.title}
                </div>
                {n.message && <div style={{ fontSize:'13px', color:'var(--text2)', lineHeight:1.5 }}>{n.message}</div>}
                <div style={{ fontSize:'11px', color:'var(--text3)', marginTop:'6px' }}>
                  {new Date(n.created_at).toLocaleString('en-BD', { dateStyle:'medium', timeStyle:'short' })}
                </div>
              </div>
              {!n.is_read && (
                <div style={{ width:8, height:8, borderRadius:'50%', background:'var(--brand)', flexShrink:0, marginTop:'6px' }} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
